import { WorkflowRole } from '@exam-management/common/types';

interface GetWorkflowRoleForTaskParams {
  userId: string;
  assigneeId: string;
  assignerId: string;
  ownerId: string;
}

export function getWorkflowRoleForTask({
  userId,
  assigneeId,
  assignerId,
  ownerId,
}: GetWorkflowRoleForTaskParams) {
  const workflowRoles = [];

  if (userId === assigneeId) workflowRoles.push(WorkflowRole.TASK_ASSIGNEE);
  if (userId === assignerId) workflowRoles.push(WorkflowRole.TASK_ASSIGNER);
  if (userId === ownerId) workflowRoles.push(WorkflowRole.TASK_OWNER);

  return workflowRoles;
}

interface GetWorkflowRoleForSubtaskParams {
  userId: string;
  assigneeId: string;
  assignerId: string;
  parentOwnerId: string;
}

export function getWorkflowRoleForSubtask({
  userId,
  assigneeId,
  assignerId,
  parentOwnerId,
}: GetWorkflowRoleForSubtaskParams) {
  const workflowRoles = [];

  if (userId === assigneeId) workflowRoles.push(WorkflowRole.SUBTASK_ASSIGNEE);
  if (userId === assignerId) workflowRoles.push(WorkflowRole.SUBTASK_ASSIGNER);
  // REMARK: the real owner task of subtask is the owner of parent task
  if (userId === parentOwnerId) workflowRoles.push(WorkflowRole.TASK_OWNER);

  return workflowRoles;
}
